import React from 'react';

import Box from '@mui/material/Box';

import Typography from '@ts-core/components/Typography';

interface ExerciseTextProps {
  text?: string;
  loading?: boolean;
}

const ExerciseText = (props: ExerciseTextProps) => {
  const { text, loading = false } = props;

  if (!text && !loading) {
    return <span />;
  }

  return (
    <Box p={1} sx={{ backgroundColor: '#f3f3f3', height: loading ? '100%' : undefined }}>
      <Typography variant="body2" sx={{ whiteSpace: 'pre-line' }} loading={loading} skeletonProps={{ lines: 3, lastLineWidth: '50%' }}>
        {text}
      </Typography>
    </Box>
  );
};

export default ExerciseText;
